import { Modal, Row, Col } from "antd";
import { useForm } from "react-hook-form";
import { Box, Flex } from "@chakra-ui/react";
import Field from "components/Input/Field/index";
import { CloseModalButton } from "components/Button/CloseModalButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import SelectMedida from "components/Input/SelectMedida/index";
import { OrcamentoItem } from "core/features/orcamento/typings/index";

interface ModalItemSerCotadosProps {
  isOpen: boolean;
  onClose: () => any;
  onSaved: (data: any) => any;
  isEdit?: boolean;
  defaultData?: Partial<OrcamentoItem>;
}

function ModalItemSerCotado({
  isOpen,
  onClose,
  onSaved,
  isEdit,
  defaultData,
}: ModalItemSerCotadosProps) {
  const { control, handleSubmit } = useForm<OrcamentoItem>({
    defaultValues: {
      ...defaultData,
    },
  });

  const onSubmit = async (data: OrcamentoItem) => {
    onSaved(data);
  };

  return (
    <Modal
      centered
      visible={isOpen}
      footer={
        <Flex justifyContent="end">
          <CloseModalButton close={onClose} closeModalLabel="Cancelar" />
          <PrimaryButton ml={5} mr={2} onClick={() => handleSubmit(onSubmit)()}>
            Salvar
          </PrimaryButton>
        </Flex>
      }
      title={(isEdit ? "Editar" : "Adicionar") + " item a ser cotado"}
      destroyOnClose
      onCancel={onClose}
      closable={true}
      width="600px"
    >
      <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
        <Box>
          <Box as={Row} gutter={32} mb={6}>
            <Box as={Col} xs={24}>
              <Field
                control={control}
                name="nome"
                label="Nome do item"
                rules={{ required: true }}
              />
            </Box>
          </Box>
          <Box as={Row} gutter={32} mb={6}>
            <Box as={Col} xs={18}>
              <Field
                control={control}
                name="unidadeMedidaId"
                label="Medida"
                rules={{ required: true }}
                render={({ field }) => (
                  <Flex alignItems="center">
                    <SelectMedida {...field} />
                  </Flex>
                )}
              />
            </Box>
            <Box as={Col} xs={6}>
              <Field
                control={control}
                name="quantidade"
                label="Quantidade"
                rules={{ required: true }}
              />
            </Box>
          </Box>
        </Box>
      </form>
    </Modal>
  );
}

export default ModalItemSerCotado;
